import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TagsFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class ACoupon extends ABusiness {
    readonly icon = () => h(TagsFilled, {style: 'color:#22c55e'});
    readonly title = '优惠券';
    readonly description = '用小幅让利作为杠杆，既能撬动新客下单和沉默用户回流，也能有效清理库存。';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {active: [], preheating: [], finished: []}[status]
    }
}